import { IconeProprio, type PropsIcone } from './base'

/**
 * Ícone próprio de calço escalonado de resgate veicular (step chock) com volume 3D.
 *
 * Representa o bloco maciço de cribbing em perspectiva isométrica/volumétrica:
 * 4 degraus largos com superfície superior de apoio (degraus progressivos),
 * espessura e profundidade do bloco, vão interno de empunhadura, base sólida
 * e alça traseira para transporte rápido na cena de desencarceramento.
 */
export function IconeEstabilizacao(props: PropsIcone) {
  return (
    <IconeProprio {...props}>
      {/* Alça traseira de transporte rápido */}
      <path d="M3 11C1.6 11 1 11.8 1 12.8c0 .9.6 1.7 2 1.7" />

      {/* Face frontal com 4 degraus largos de apoio estrutural */}
      <path d="M3 19.5V8h3.5v3h4v3h4v3h4v2.5H3z" />

      {/* Profundidade volumétrica 3D: degraus e risers da face posterior */}
      <path d="M6 5h3.5v3h4v3h4v3h4v2.5" />

      {/* Arestas de projeção de profundidade nos degraus */}
      <path d="M3 8l3-3" />
      <path d="M6.5 8l3-3" />
      <path d="M10.5 11l3-3" />
      <path d="M14.5 14l3-3" />
      <path d="M18.5 17l3-3" />
      <path d="M18.5 19.5l3-3" />

      {/* Vão ergonômico de empunhadura no corpo maciço do bloco */}
      <rect x="4.8" y="11.5" width="1.8" height="4.5" rx="0.9" />

      {/* Base sólida de apoio ao solo */}
      <path d="M2 19.5h17" />
    </IconeProprio>
  )
}

/** Sinônimo descritivo do calço escalonado. */
export const IconeCalcoEscalonado = IconeEstabilizacao

/** Compatibilidade com o registro de módulos. */
export const IconeModuloEstabilizacao = IconeEstabilizacao
